import { createRouter, createWebHistory } from 'vue-router'

export default createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/connections' },
    { path: '/connections', name: 'connections', component: () => import('@pages/ConnectionsPage.vue') },
    { path: '/connections/new', name: 'connection-new', component: () => import('@pages/ConnectionNewPage.vue') },
    { path: '/connections/:id', name: 'connection', component: () => import('@pages/ConnectionPage.vue') },
    { path: '/operations', name: 'operations', component: () => import('@pages/OperationsPage.vue') },
    { path: '/runs', name: 'runs', component: () => import('@pages/RunsPage.vue') },
    { path: '/devices', name: 'devices', component: () => import('@pages/DevicesPage.vue') },
    { path: '/insights', name: 'insights', component: () => import('@pages/InsightsPage.vue') },
    { path: '/query', name: 'query', component: () => import('@pages/QueryPage.vue') },
    { path: '/rules', name: 'rules', component: () => import('@pages/RulesPage.vue') },
    { path: '/traffic', name: 'traffic', component: () => import('@pages/TrafficPage.vue') },
    { path: '/presentations', name: 'presentations', component: () => import('@pages/PresentationsPage.vue') },
    { path: '/issuers', name: 'issuers', component: () => import('@pages/IssuersPage.vue') },
    { path: '/gateway', name: 'gateway', component: () => import('@pages/GatewayPage.vue') },
    { path: '/credentials', name: 'credentials', component: () => import('@pages/CredentialsPage.vue') },
    { path: '/keys', name: 'keys', component: () => import('@pages/KeysPage.vue') },
    { path: '/connectors', name: 'connectors', component: () => import('@pages/ConnectorsPage.vue') },
    { path: '/:pathMatch(.*)*', component: () => import('@pages/ConnectionsPage.vue') }
  ]
})
